export default function Loading({ visible }) {
  if (!visible) return null;

  return (
    <div className="flex flex-row gap-2 bg bg-primary/50">
      <div className="w-2 h-2 !rounded-full bg-white animate-bounce [animation-delay:.7s]"></div>
      <div className="w-2 h-2 !rounded-full bg-white animate-bounce [animation-delay:.3s]"></div>
      <div className="w-2 h-2 !rounded-full bg-white animate-bounce [animation-delay:.7s]"></div>
    </div>
  );
};
